import API from 'constants/API';

import {AxiosResponse} from 'axios';
import {UpdateProfileDTO} from 'typescript/dto/updateProfileDto';
import User from 'typescript/models/User';
import httpClient from 'utils/httpClient/httpClient';

export const updateUserProfile = (data: UpdateProfileDTO, userId: string): Promise<AxiosResponse<User>> => {
  const requestData = {user: data};

  return httpClient.put(`${API.AUTH_SERVICE.BASE}/${userId}`, requestData);
};
